import { Icon } from "../../../components/BaseComponents/Icon";

export const ChevronRightIcon = (props) => (
	<Icon viewBox="0 0 18 18" fill="none" {...props}>
		<path
			d="M12 9a.994.994 0 01-.292.705l-3.992 3.99a1 1 0 11-1.436-1.387l.025-.024L9.591 9 6.305 5.715A1 1 0 017.69 4.28l.025.025 3.991 3.99A.994.994 0 0112 9z"
			fill="currentColor"
		/>
	</Icon>
);
